import type { DateTime } from 'luxon'

const TIME_FORMAT = 'h:mm a'
const DATE_FORMAT_BY_TYPE = {
  'day-of-week': 'EEE',
  'day-of-month': 'LLL d',
} as const

export default function getSessionTimespanString({
  startDate,
  endDate,
  dateFormat,
}: {
  startDate: DateTime
  endDate: DateTime
  dateFormat: 'day-of-week' | 'day-of-month'
}): string {
  const isSameDay = startDate.day === endDate.day
  const datePrefix = DATE_FORMAT_BY_TYPE[dateFormat]

  const startTimeString = startDate.toFormat(`${datePrefix} ${TIME_FORMAT}`)
  const endTimeString = endDate.toFormat(`${isSameDay ? '' : `${datePrefix} `}${TIME_FORMAT} ZZZZ`)
  return `${startTimeString} - ${endTimeString}`
}
